import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/light-mode-overrides.css";
import App from "@/App";

const savedTheme = localStorage.getItem("sft-theme") || "dark";
document.documentElement.classList.remove("dark", "light");
document.documentElement.classList.add(savedTheme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
